import { pageMeta } from '@/seo/siteMeta';

export const routes = [
  {
    path: '/data-table',
    component: render('frontend/DataTable'),
    meta: pageMeta.dataTable,
  },
  {
    path: '/landing',
    component: render('frontend/MainMenu'),
    meta: pageMeta.landing,
  },
  {
    path: '/android-guide',
    component: render('frontend/AndroidGuide'),
    meta: pageMeta.androidGuide,
  },
  {
    path: '/ios-guide',
    component: render('frontend/IOSGuide'),
    meta: pageMeta.iosGuide,
  },
  {
    path: '',
    component: render('frontend/Index'),
    children: [
      {
        path: '/',
        component: render('frontend/Home'),
        meta: pageMeta.home,
      },
      {
        path: '/auth/login',
        component: render('frontend/auth/Login'),
        meta: pageMeta.login,
      },
      {
        path: '/auth/register',
        component: render('frontend/auth/Register'),
        meta: pageMeta.register,
      },
      {
        path: '/auth/verify',
        component: render('frontend/auth/Verify'),
        meta: pageMeta.verify,
      },
      {
        path: '/auth/not-auth-verify',
        component: render('frontend/auth/VerifyNotAuth'),
        meta: pageMeta.verify,
      },
      {
        path: '/home',
        component: render('frontend/Home'),
        meta: pageMeta.home,
      },
      {
        path: '/rule',
        component: render('frontend/auth/Rule'),
        meta: pageMeta.rule,
      },
      {
        path: '/slots',
        component: render('frontend/normal-user/game/Slot'),
        meta: pageMeta.slots,
      },
      {
        path: '/fishing',
        component: render('frontend/normal-user/game/Fishing'),
        meta: pageMeta.fishing,
      },
      {
        path: '/betslip-history',
        component: render('frontend/BetslipHistory'),
        meta: pageMeta.betslip,
      },
      {
        path: '/live-score',
        component: render('frontend/LiveScore'),
        meta: pageMeta.liveScore,
      },
      {
        path: '/history',
        component: render('frontend/History'),
        meta: pageMeta.history,
      },
      {
        path: '/maung-fb',
        component: render('frontend/MaungFB'),
        meta: pageMeta.maungFb,
      },
      {
        path: '/body-fb',
        component: render('frontend/BodyFB'),
        meta: pageMeta.bodyFb,
      },
      {
        path: '/setting',
        component: render('frontend/Setting'),
        meta: pageMeta.setting,
      },
      {
        path: '/contact-us',
        component: render('frontend/ContactUs'),
        meta: pageMeta.contact,
      },
      {
        path: '/promotion',
        component: render('frontend/Promotion'),
        meta: pageMeta.promotion,
      },
      {
        path: '/live',
        component: render('frontend/Live'),
        meta: pageMeta.liveCasino,
      },
      {
        path: '/football-result',
        component: render('frontend/MatchResult'),
        meta: pageMeta.matchResult,
      },
      {
        path: '/video-links',
        component: render('frontend/VideoLink'),
        meta: pageMeta.videoLinks,
      },
      {
        path: '/deposit',
        component: render('frontend/Deposit'),
        meta: pageMeta.deposit,
      },
      {
        path: '/withdraw',
        component: render('frontend/Withdraw'),
        meta: pageMeta.withdraw,
      },
      {
        path: '/banking',
        component: render('frontend/Banking'),
        meta: pageMeta.banking,
      },
      {
        path: '/commission',
        component: render('frontend/Commission'),
        meta: pageMeta.commission,
      },
      {
        path: '/level',
        component: render('frontend/VipLevels'),
        meta: pageMeta.level,
      },
      {
        path: '/iframeURL',
        component: render('frontend/Iframe'),
        meta: pageMeta.iframe,
      },
      {
        path: '/user',
        component: render('frontend/normal-user/Index'),
        children: [
          {
            path: 'dream-books',
            component: render('frontend/normal-user/DreamBooks'),
            meta: pageMeta.dreamBooks,
          },
          {
            path: '2d/home',
            component: render('frontend/normal-user/2d/Home'),
            meta: pageMeta.twoD,
          },
          {
            path: '2d',
            component: render('frontend/normal-user/2d/2d'),
            meta: pageMeta.twoD,
          },
          {
            path: '2d/closed',
            component: render('frontend/normal-user/2d/ClosedDays'),
            meta: pageMeta.twoD,
          },
          {
            path: '2d/winner',
            component: render('frontend/normal-user/2d/Winner'),
            meta: pageMeta.twoD,
          },
          {
            path: '3d/home',
            component: render('frontend/normal-user/3d/Home'),
            meta: pageMeta.threeD,
          },
          {
            path: '3d',
            component: render('frontend/normal-user/3d/3d'),
            meta: pageMeta.threeD,
          },
          {
            path: 'slots',
            component: render('frontend/normal-user/game/Slot'),
            meta: pageMeta.slots,
          },
          {
            path: 'arcade',
            component: render('frontend/normal-user/game/Arcade'),
            meta: pageMeta.arcade,
          },
          {
            path: 'game',
            component: render('frontend/normal-user/game/Game'),
            meta: pageMeta.cardGames,
          },
          {
            path: 'fishing',
            component: render('frontend/normal-user/game/Fishing'),
            meta: pageMeta.fishing,
          },
          {
            path: 'skm-rooms',
            component: render('frontend/normal-user/shankomee/Room'),
            meta: pageMeta.shanKoeMee,
          },
          {
            path: 'bugyee-rooms',
            component: render('frontend/normal-user/bugyee/Room'),
            meta: pageMeta.bugyee,
          },
        ],
      },
    ],
  },
];

function render(template) {
  return require(`@/pages/${template}.vue`).default;
}
